import { ReadonlyCollection } from "@ioip/core/lib";
import { DataTableColumn } from "./DataTableColumn";
import { Field, IFieldProps } from "./Field";

export interface IDataTableProps extends IFieldProps { }

export class DataTable extends Field {

    $columns: ReadonlyCollection<DataTableColumn>;

    constructor(props: IDataTableProps) {
        super(props);
        this.$columns = new ReadonlyCollection<DataTableColumn>(props.schema.columns.map(x => new DataTableColumn({ schema: x })));
    }

    get columns(): ReadonlyCollection<DataTableColumn> {
        return this.$columns;
    }

}